import { FIELD as PERSONAL_DETAILS_FIELD } from 'screens/BrokerPortal/screens/Registration/components/PersonalDetailsStep/types';
import { ACTION_TYPES, State } from './types';

const initialState: State = {
  currentStep: undefined,
  context: {
    firm: null,
  },
  searchFirms: {
    form: {
      firmId: null,
    },
    firms: {
      loading: false,
      items: [],
    },
  },
  registerFirm: {
    networks: {
      loading: false,
      items: [],
    },
    clubs: {
      loading: false,
      items: [],
    },
    form: {
      firmName: null,
      fcaNumber: null,
      searchFirmAddress: null,
      firmEmail: null,
      firmPhone: null,
      firmType: null,
      hasPermissionToRegisterFirm: null,
      network: null,
      club: null,
      addressLine1: null,
      addressLine2: null,
      addressLine3: null,
      city: null,
      county: null,
      postcode: null,
    },
    addAddressManually: false,
  },
  dueDiligence: {
    form: {
      companiesHouseNumber: null,
      managementDob: null,
      icoProtectionNumber: null,
      financialCrimePolicy: null,
      dataProtectionPolicy: null,
      treatingCustomerFairlyPolicy: null,
      disasterRecoveryPolicy: null,
      numberOfComplaintsReceived: null,
      numberOfComplaintsUpheld: null,
      employeeAccessRemovalProcess: null,
      piiInPlaceWithFCARequirements: null,
      sensitiveDataPolicy: null,
      additionalInformation: null,
      agreedToTermsAndConditions: null,
      whoCarriesComplianceOversight: null,
    },
  },
  personalDetails: {
    form: {
      [PERSONAL_DETAILS_FIELD.FIRST_NAME]: null,
      [PERSONAL_DETAILS_FIELD.SURNAME]: null,
      [PERSONAL_DETAILS_FIELD.EMAIL]: null,
      [PERSONAL_DETAILS_FIELD.CONTACT_NUMBER]: null,
      [PERSONAL_DETAILS_FIELD.ROLE]: null,
      [PERSONAL_DETAILS_FIELD.HOW_DID_USER_HEAR_ABOUT_LIVEMORE]: null,
      [PERSONAL_DETAILS_FIELD.OPTIONAL_DETAILS]: null,
    },
    registerLoading: false,
  },
};

function reducer(state = initialState, action: any) {
  switch (action.type) {
    case ACTION_TYPES.SET_SEARCH_FIRMS_FORM:
      return { ...state, searchFirms: { ...state.searchFirms, form: action.payload } };
    case ACTION_TYPES.SET_SEARCH_FIRMS_FIRMS_ITEMS:
      return {
        ...state,
        searchFirms: { ...state.searchFirms, firms: { ...state.searchFirms.firms, items: action.payload } },
      };
    case ACTION_TYPES.SET_SEARCH_FIRMS_FIRMS_ITEMS_LOADING:
      return {
        ...state,
        searchFirms: { ...state.searchFirms, firms: { ...state.searchFirms.firms, loading: action.payload } },
      };
    case ACTION_TYPES.SET_REGISTER_FIRM_FORM:
      return { ...state, registerFirm: { ...state.registerFirm, form: action.payload } };
    case ACTION_TYPES.SET_DUE_DILIGENCE_FORM:
      return { ...state, dueDiligence: { ...state.dueDiligence, form: action.payload } };
    case ACTION_TYPES.SET_PERSONAL_DETAILS_FORM:
      return { ...state, personalDetails: { ...state.personalDetails, form: action.payload } };
    case ACTION_TYPES.CLEAR_REGISTRATION:
      return {
        ...state,
        ...initialState,
      };
    case ACTION_TYPES.SET_CLUB_ITEMS:
      return {
        ...state,
        registerFirm: { ...state.registerFirm, clubs: { ...state.registerFirm.clubs, items: action.payload } },
      };
    case ACTION_TYPES.SET_CLUB_ITEMS_LOADING:
      return {
        ...state,
        registerFirm: { ...state.registerFirm, clubs: { ...state.registerFirm.clubs, loading: action.payload } },
      };
    case ACTION_TYPES.SET_NETWORK_ITEMS:
      return {
        ...state,
        registerFirm: { ...state.registerFirm, networks: { ...state.registerFirm.networks, items: action.payload } },
      };
    case ACTION_TYPES.SET_NETWORK_ITEMS_LOADING:
      return {
        ...state,
        registerFirm: { ...state.registerFirm, networks: { ...state.registerFirm.networks, loading: action.payload } },
      };
    case ACTION_TYPES.SET_ADD_ADDRESS_MANUALLY:
      return {
        ...state,
        registerFirm: { ...state.registerFirm, addAddressManually: action.payload },
      };
    case ACTION_TYPES.SET_CONTEXT_FIRM:
      return {
        ...state,
        context: {
          ...state.context,
          firm: action.payload,
        },
      };
    case ACTION_TYPES.SET_REGISTER_LOADING:
      return {
        ...state,
        personalDetails: { ...state.personalDetails, registerLoading: action.payload },
      };
    case ACTION_TYPES.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
